// extracted by mini-css-extract-plugin
module.exports = {"container":"WhaleFmScreen_container__1SPqT"};